import { RarsApiService } from '@common/ApiService'
import legParams from '@utils/reservation-response-parser'

export const state = {
  errorMessage: '',
  reservationsPerLeg: {},
  allReservations: [],
}

export const mutations = {
  setErrorMessage(state, data) {
    state.errorMessage = data
  },

  setReservationResults(state, data) {
    let parsedResponse = {
      outbound: legParams(data.journeys[0].legs),
      return: !data.journeys[1] ? [] : legParams(data.journeys[1].legs),
    }
    state.reservationsPerLeg = parsedResponse

    const allLegs = parsedResponse.outbound.concat(parsedResponse.return)
    state.allReservations = allLegs.map((leg) => leg.reservations).flat()
  },
}

export const actions = {
  getAvailability({ commit }, params) {
    return RarsApiService.availability(params)
  },

  getCoaches({ commit }, params) {
    return RarsApiService.coaches(params)
  },

  cancel({ commit }, rarsRef) {
    return RarsApiService.cancel(rarsRef)
  },

  recallBookingByRef({ commit }, params) {
    return RarsApiService.recallBookingByRef(params)
  },

  recallBookingByUnit({ commit }, params) {
    return RarsApiService.recallBookingByUnit(params)
  },
}
